import React from 'react';
import { Form, Input } from 'antd';

function TextInput({
  name, label, errorMessage, disabled = false, rules = [],
}) {
  return (
    <Form.Item
      label={label}
      name={name}
      validateStatus={errorMessage && 'error'}
      help={errorMessage}
      rules={rules}
    >
      <Input disabled={disabled} />
    </Form.Item>
  );
}

export default TextInput;
